<template>
    <div v-if="(showEdit && !isMobile) || couponDiscount" class="coupon-box" >
        <div class="total-box" :class="{edit: showEdit}">
            <div class="title">{{ $t('cart.coupon.title') }}</div>
            <div class="details">
                <div class="total">
                    <template v-if="couponDiscount">
                        -{{ currency }} {{ couponDiscount.discount }}
                    </template>
                    <template v-else>
                        <div class="coupon-input-box">
                            <input
                                class="code-input"
                                :class="{'error': inputError}"
                                v-model="couponCode"
                                @input="inputError = false"
                                :placeholder="$t('cart.coupon.newPlaceholder').toString()"
                            />
                            <reo-common-button
                                :label="$t('cart.coupon.apply')"
                                colorType="dark"
                                class="confirm-button"
                                buttonClass="confirm-button-inner"
                                @click="addCoupon"
                            />
                        </div>
                        <div class="error-message" v-if="inputError">{{ errorMessage }}</div>
                    </template>
                </div>
            </div>
        </div>
        <div v-if="couponDiscount && showEdit && !isMobile" class="coupon-info">
            <text-button
                :text="$t('cart.coupon.remove')"
                :fontSize="'16px'"
                @click="removeCoupon"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { IPromotion } from '@reolink-cloud/interface';
import Vue, { PropType } from 'vue';
import TextButton from '@/basic/TextButton.vue';

export default Vue.extend({
    components: {
        TextButton
    },
    props: {
        discounts: Array as PropType<IPromotion[]>,
        currency: String,
        showEdit: Boolean
    },
    data() {

        return {
            showInputCoupon: false,
            couponCode: '',
            inputError: false,
            errorMessage: ''
        };

    },
    computed: {
        couponDiscount(): IPromotion | undefined {

            return this.discounts?.find( item => item.key === 'cloud_coupon' );

        },
        isMobile(): boolean {

            return this.$store.getters.isMobile;

        }
    },
    methods: {
        addCoupon() {

            if ( this.couponCode ) {

                this.inputError = false;
                // 传递回调函数给父组件
                this.$emit( 'addCoupon', this.couponCode.trim(), 'add', ( success: { couponError: string; hasCouponError: boolean; }) => {

                    if ( success.hasCouponError ) {

                        this.errorMessage = success.couponError;
                        this.inputError = true;

                    }

                });

            }
            else {

                this.inputError = true;
                this.errorMessage = this.$t( 'cart.coupon.required' ).toString();

            }

        },
        removeCoupon() {

            this.couponCode = '';
            this.$emit( 'addCoupon', this.couponCode, 'remove' );

        },
        handleShowInputCoupon() {

            if ( this.showEdit ) {

                this.showInputCoupon = !this.showInputCoupon;

            }

        }
    }
});
</script>

<style lang="less" scoped>
.coupon-box{
    padding-bottom: 16px;
    .mobile({
        width: 100% !important;
    });
    .total-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.edit{
            cursor: pointer;
        }
        .title{
            font-size: 16px;
        }
        .details{
            display: flex;
            align-items: center;
            width: 70%;
            justify-content: flex-end;
            .total{
                font-size: 16px;
                color: @red_5;
                margin-right: 4px;
                font-weight: 600;
                .coupon-input-box{
                    display: flex;
                    flex-direction: row;
                    border-radius: 4px;
                    height: 34px;
                    .code-input{
                        padding: 8px 12px;
                        box-shadow: none;
                        box-sizing: border-box;
                        width: 100%;
                        border: 1px solid #E1E1E1;
                        border-radius: 4px 0 0 4px;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 1.3;
                        &:hover {
                            border-color: var(--b_6);
                        }
                        &:focus {
                            border-color: var(--b_6);
                        }
                        &.error{
                            border-color: @red_5;
                        }
                    }
                    .confirm-button{
                        width: auto;
                        /deep/ .button-label{
                            white-space: nowrap;
                        }
                    }
                }
                .error-message{
                    color: @red_5;
                    font-size: 12px;
                    font-weight: normal;
                    margin-top: 4px;
                    text-align: start;
                }
            }
            .icon{
                font-size: 11px;
            }
        }
    }
    .detail-box{
        background-color: @bg_01;
        padding: 12px;
        margin-top: 6px;
        .detail-item{
            display: flex;
            justify-content: space-between;
            .name{
                font-size: 14px;
            }
            .value{
                font-size: 14px;
                font-weight: 600;
                color: @red_5;
            }
        }
    }
    .coupon-info{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .code{
            font-size: 12px;
            color: @font_secondary;
        }
    }
}

.dialog-content{
    padding: 0 96px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: fit-content;
    box-sizing: border-box;
    .mobile({
        padding: 0;
        width: 100%;
    });
    h2{
        margin-bottom: 8px;
        font-size: 20px;
        font-weight: 600;
        text-align: center;
    }
    .code-input{
        border-radius: 8px;
        border: 1px solid @font_tertiary;
        padding: 16px;
        box-shadow: none;
        width: 360px;
        .mobile({
            width: 100%;
            box-sizing: border-box
        });
        &::placeholder{
            color: @font_secondary;
        }
    }
}
</style>
